import React from "react";
import { Container, Row, Col } from "shards-react";
import DetailUser from "../components/user/DetailUser";

class User extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        {/* <Row noGutters className="page-header py-4">
          <PageTitle title="" subtitle="" md="12" className="ml-sm-auto mr-sm-auto" />
        </Row> */}
        <Row className="py-3">
          <Col lg="12">
            <DetailUser userId={this.props.match.params.id} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default User;
